import { render, staticRenderFns } from "./comAbout.vue?vue&type=template&id=770c2d80&scoped=true"
import script from "./comAbout.vue?vue&type=script&lang=js"
export * from "./comAbout.vue?vue&type=script&lang=js"
import style0 from "./comAbout.vue?vue&type=style&index=0&id=770c2d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c2d80",
  null
  
)

export default component.exports